import _ from 'lodash'
import core from '../../core'

import { valueTable as commonConfigValues } from './commonConfig'

const { theirRole, decision } = commonConfigValues

const {
  helpers: { keepInLength, calculatePeriod, getLoginFromMail, getUserId }
} = core

const styles = {
  floatingLabel: { fontSize: '1.1rem' },
  fieldText: { fontSize: '0.8rem' }
}

export const locationType = [
  { id: 1, label: 'On-Site' },
  { id: 2, label: 'Off-Site' },
  { id: 3, label: 'N / A' }
]

export const eventType = [
  { id: 1, label: 'Centre 121 Session excl. PPW' },
  { id: 2, label: 'Centre Fire Drill' },
  { id: 3, label: 'Centre Induction' },
  { id: 4, label: 'Court Attendance' },
  { id: 5, label: 'Homework / Study Completion' },
  { id: 6, label: 'Meeting Attendance' },
  { id: 7, label: 'Personal Access' },
  { id: 8, label: 'Placement Plan Work' },
  { id: 9, label: 'Professional Access' },
  { id: 10, label: 'School / Course Attendance' },
  { id: 11, label: 'Social / Leisure Activity' },
  { id: 12, label: 'YP Consultation' },
  { id: 13, label: 'YP Training' },
  { id: 14, label: 'Other' }
]

export const structureStatus = [
  { id: 1, label: 'Structured' },
  { id: 2, label: 'Unstructured' },
  { id: 3, label: 'N / A' }
]

export const exerciseStatus = [
  { id: 1, label: 'Physical' },
  { id: 2, label: 'Sedentary' },
  { id: 3, label: 'N / A' }
]

export const expenditureStatus = [
  { id: 1, label: 'Free' },
  { id: 2, label: 'Paid' },
  { id: 3, label: 'N / A' }
]

export const supervisionStatus = [
  { id: 1, label: 'Supervised' },
  { id: 2, label: 'Unsupervised' },
  { id: 3, label: 'N / A' }
]

export const meetingPurpose = [
  { id: 1, label: 'Centre YP Meeting' },
  { id: 2, label: 'Centre YP Meeting - Team Feedback' },
  { id: 3, label: 'Child in Care Review' },
  { id: 4, label: 'Presentation Issue / Risk Related' },
  { id: 5, label: 'School / Course Related - Non-Routine' },
  { id: 6, label: 'School / Course Related - Routine' },
  { id: 7, label: 'Social / Leisure Activity Related' },
  { id: 8, label: 'Other' }
]

export const valueTable = {
  locationType,
  eventType,
  structureStatus,
  exerciseStatus,
  expenditureStatus,
  supervisionStatus,
  meetingPurpose
}

export const views = [
  {
    id: 1,
    viewName: 'QuickView',
    columns: [
      'person.fullName',
      'event.date',
      'event.locationType',
      'event.location',
      'event.type',
      'event.notes'
    ]
  }
]

export const columns = [
  {
    name: 'id',
    title: 'ID',
    hidden: true,
    formField: true
  },
  {
    name: 'register.personId',
    title: 'YP UI',
    minSpace: 'YP UIw ',
    formField: true
  },
  {
    name: 'register.person.firstName',
    title: 'YP First Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.lastName',
    title: 'YP Last Name',
    hidden: true,
    minSpace: 'YP ',
    formField: true
  },
  {
    name: 'register.person.fullName',
    title: 'YP Name',
    formField: true,
    getCellValue: row =>
      `${row['register.person.firstName']} ${row['register.person.lastName']}`,
    maxChars: 100,
    minSpace: 'YP Name '
  },
  {
    name: 'event.date',
    title: 'Event Date',
    formField: true,
    type: 'date',
    filterField: true,
    minSpace: 'Event '
  },
  {
    name: 'event.startTime',
    title: 'Event Start Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'Start Time   '
  },
  {
    name: 'event.endTime',
    title: 'Event End Time',
    formField: true,
    type: 'time',
    filterField: true,
    minSpace: 'End Time   '
  },
  {
    name: 'event.duration',
    title: 'Event Duration',
    formField: true,
    getCellValue: row =>
      calculatePeriod(row[`event.startDate`], row[`event.endDate`]),
    //calculated field
    filterField: true,
    minSpace: 'Duration '
  },
  {
    name: 'event.locationType',
    title: 'Event Location Type',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(locationType, ['id', parseInt(row[`event.locationType`], 10)])
        ? _.find(locationType, ['id', parseInt(row[`event.locationType`], 10)])
            .label
        : row[`event.locationType`],
    options: 'locationType',
    filterField: true,
    minSpace: 'Event Location '
  },
  {
    name: 'event.location',
    title: 'Event Location',
    formField: true,
    maxChars: 300,
    minSpace: 'Event Location '
  },
  {
    name: 'event.type',
    title: 'Event Type',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(eventType, ['id', parseInt(row[`event.type`], 10)])
        ? _.find(eventType, ['id', parseInt(row[`event.type`], 10)]).label
        : row[`event.type`],
    options: 'eventType',
    filterField: true,
    minSpace: 'Event Type '
  },
  {
    name: 'event.structureStatus',
    title: 'Social / Leisure Activity Structure Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(structureStatus, [
        'id',
        parseInt(row[`event.structureStatus`], 10)
      ])
        ? _.find(structureStatus, [
            'id',
            parseInt(row[`event.structureStatus`], 10)
          ]).label
        : row[`event.structureStatus`],
    options: 'structureStatus',

    //conditional to event.type
    filterField: true,
    minSpace: 'Activity Structure Status '
  },
  {
    name: 'event.exerciseStatus',
    title: 'Social / Leisure Activity Exercise Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(exerciseStatus, ['id', parseInt(row[`event.exerciseStatus`], 10)])
        ? _.find(exerciseStatus, [
            'id',
            parseInt(row[`event.exerciseStatus`], 10)
          ]).label
        : row[`event.exerciseStatus`],
    options: 'exerciseStatus',
    //conditional to event.type
    filterField: true,
    minSpace: 'Activity Exercise Status '
  },
  {
    name: 'event.expenditureStatus',
    title: 'Social / Leisure Activity Expenditure Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(expenditureStatus, [
        'id',
        parseInt(row[`event.expenditureStatus`], 10)
      ])
        ? _.find(expenditureStatus, [
            'id',
            parseInt(row[`event.expenditureStatus`], 10)
          ]).label
        : row[`event.expenditureStatus`],
    options: 'expenditureStatus',
    //conditional to event.type
    filterField: true,
    minSpace: 'Activity Expenditure Status '
  },
  {
    name: 'event.supervisionStatus',
    title: 'Event Supervision Status',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(supervisionStatus, [
        'id',
        parseInt(row[`event.supervisionStatus`], 10)
      ])
        ? _.find(supervisionStatus, [
            'id',
            parseInt(row[`event.supervisionStatus`], 10)
          ]).label
        : row[`event.supervisionStatus`],
    options: 'supervisionStatus',
    //conditional to event.type
    filterField: true,
    minSpace: 'Event Supervision '
  },
  {
    name: 'event.supervisorName',
    title: 'Supervisor Name(s)',
    formField: true,
    filterField: true,
    //conditional to event.type
    maxChars: 100,
    minSpace: 'Supervisor Name(s) '
  },
  {
    name: 'event.supervisorRole',
    title: 'Supervisor Role(s)',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`event.supervisorRole`], 10)])
        ? _.find(theirRole, ['id', parseInt(row[`event.supervisorRole`], 10)])
            .label
        : row[`event.supervisorRole`],
    options: 'theirRole',
    //conditional to event.type
    filterField: true,
    minSpace: 'Supervisor '
  },
  {
    name: 'event.meetingPurpose',
    title: 'Meeting Purpose',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(meetingPurpose, ['id', parseInt(row[`event.meetingPurpose`], 10)])
        ? _.find(meetingPurpose, [
            'id',
            parseInt(row[`event.meetingPurpose`], 10)
          ]).label
        : row[`event.meetingPurpose`],
    options: 'meetingPurpose',
    //conditional to event.type
    filterField: true,
    minSpace: 'Meeting '
  },
  {
    name: 'event.involvedName',
    title: 'Persons Present / Involved Name(s)',
    formField: true,
    maxChars: 100,
    minSpace: 'Persons Present / '
  },
  {
    name: 'event.theirRoleInvolved',
    title: 'Their Role(s)',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(theirRole, ['id', parseInt(row[`event.theirRoleInvolved`], 10)])
        ? _.find(theirRole, [
            'id',
            parseInt(row[`event.theirRoleInvolved`], 10)
          ]).label
        : row[`event.theirRoleInvolved`],
    options: 'theirRole',
    filterField: true,
    minSpace: 'Their Role(s) '
  },
  {
    name: 'event.involved',
    title: 'Young Person Involved?',
    formField: true,
    type: 'select',
    getCellValue: row =>
      _.find(decision, ['id', parseInt(row[`event.involved`], 10)])
        ? _.find(decision, ['id', parseInt(row[`event.involved`], 10)]).label
        : row[`event.involved`],
    options: 'decision',
    filterField: true,
    minSpace: 'Young Person '
  },
  {
    name: 'event.notes',
    title: 'Event Notes ',
    formField: true,
    maxChars: 500,
    filterField: true,
    minSpace: 'Event Notes '
  }
]

export const getSubForms = ({
  data: { centres, persons, reasons },
  fields,
  change,
  formName,
  showAsterix,
  openToYearSelection,
  hideCalendarDate,
  disabled,
  add,
  formValues,
  proceedSelectionChange,
  personAdd,
  availableValues
}) => {
  const forms = [
    {
      id: 1,
      name: 'reg',
      activeName: 'event',
      historyName: 'eventHistory',
      label: 'Register',
      icon: 'note',
      fields: [
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'registerId',
          disabled: !add,
          label: 'Register Entry',
          // hint: 'Select Register Entry',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.register.filter(f => f.id > 0).map(o => {
            const person = _.find(availableValues.persons, ['id', o.personId])
            const label = `${person.firstName} ${person.lastName} (register: ${
              o.id
            })`
            return { value: o.id, label: label }
          })
        }
      ]
    },
    {
      id: 2,
      name: 'eve',
      activeName: 'event',
      historyName: 'eventHistory',
      label: 'Events',
      icon: 'note',
      fields: [
        [
          {
            type: fields.datepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'event.date',
            label: 'Event Date',
            required: showAsterix,
            openToYearSelection: openToYearSelection,
            hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'event.startTime',
            label: 'Event Start Time',
            required: showAsterix,
            minutesStep: 1,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.timepicker,
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'event.endTime',
            label: 'Event End Time',
            required: showAsterix,
            minutesStep: 1,
            // openToYearSelection: openToYearSelection,
            //hideCalendarDate: hideCalendarDate,
            textFieldStyle: { width: '100%', ...styles.fieldText },
            validate: v => (v ? undefined : 'Field is required')
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'event.duration',
            label: 'Event Duration',
            disabled: true,
            required: showAsterix
          }
        ],
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'event.locationType',
            label: 'Event Location Type',
            // hint: 'Select Type',
            required: showAsterix,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.locationType
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            rows: 1,
            maxRows: 10,
            required: showAsterix,
            name: 'event.location',
            label: 'Event Location',
            // hint: 'Enter Location',
            normalize: v => {
              const val = keepInLength(v, 300)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'event.type',
          label: 'Event Type',
          // hint: 'Select Type',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.eventType.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'event.structureStatus',
            label: 'Social / Leisure Activity Structure Status',
            // hint: 'Select Status',
            required: showAsterix,
            hidden:
              formValues && formValues.event && formValues.event.type !== 11,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.structureStatus
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'event.exerciseStatus',
            label: 'Social / Leisure Activity Exercise Status',
            // hint: 'Select Status',
            required: showAsterix,
            hidden:
              formValues && formValues.event && formValues.event.type !== 11,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.exerciseStatus
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'event.expenditureStatus',
            label: 'Social / Leisure Activity Expenditure Status',
            // hint: 'Select Status',
            required: showAsterix,
            hidden:
              formValues && formValues.event && formValues.event.type !== 11,
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.expenditureStatus
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          }
        ],
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'event.supervisionStatus',
          label: 'Event Supervision Status',
          // hint: 'Select Status',
          required: showAsterix,
          hidden:
            formValues &&
            formValues.event &&
            !_.includes([7, 5, 10], formValues.event.type),
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.supervisionStatus
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          required: showAsterix,
          name: 'event.supervisorName',
          label: 'Supervisor Name(s)',
          // hint: 'Enter Name(s)',
          normalize: v => {
            const val = keepInLength(v, 100)
            return val
          },
          hidden:
            formValues &&
            formValues.event &&
            !_.includes([7, 5, 10], formValues.event.type),
          validate: v => (v ? undefined : 'Field is required')
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'event.supervisorRole',
          label: 'Event Supervisor Role',
          // hint: 'Select Role',
          required: showAsterix,
          hidden:
            formValues &&
            formValues.event &&
            !_.includes([7, 5, 10], formValues.event.type),
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.supervisionStatus
            .filter(f => f.id > 0)
            .map(o => {
              return { value: o.id, label: o.label }
            })
        },
        [
          {
            type: fields.select,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            name: 'event.meetingPurpose',
            label: 'Meeting Purpose',
            // hint: 'Select Purpose',
            required: showAsterix,
            hidden:
              formValues &&
              formValues.event &&
              !_.includes([6], formValues.event.type),
            validate: v => (v ? undefined : 'Field is required'),
            options: availableValues.meetingPurpose
              .filter(f => f.id > 0)
              .map(o => {
                return { value: o.id, label: o.label }
              })
          },

          {
            type: fields.text,
            style: { ...styles.fieldText },
            floatingLabelStyle: { ...styles.floatingLabel },
            required: showAsterix,
            name: 'event.involvedName',
            label: 'Persons Present / Involved Name(s)',
            // hint: 'Enter Name(s)',
            hidden:
              formValues &&
              formValues.event &&
              !_.includes([6], formValues.event.type),
            normalize: v => {
              const val = keepInLength(v, 100)
              return val
            },
            validate: v => (v ? undefined : 'Field is required')
          }
        ],

        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'event.theirRoleInvolved',
          label: 'Their Role(s)',
          required: showAsterix,
          multiple: true,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.theirRole.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        {
          type: fields.select,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          name: 'event.involved',
          label: 'Young Person Involved?',
          // hint: 'Select Decision',
          required: showAsterix,
          validate: v => (v ? undefined : 'Field is required'),
          options: availableValues.decision.filter(f => f.id > 0).map(o => {
            return { value: o.id, label: o.label }
          })
        },
        {
          type: fields.text,
          style: { ...styles.fieldText },
          floatingLabelStyle: { ...styles.floatingLabel },
          rows: 1,
          maxRows: 10,
          required: showAsterix,
          name: 'event.notes',
          label: 'Event Notes',
          // hint: 'Enter Event Notes',
          normalize: v => {
            const val = keepInLength(v, 500)
            return val
          },
          validate: v => (v ? undefined : 'Field is required')
        }
      ]
    }
  ]

  return forms
}

export const activeSection = ['event']

export const errors = [1, 2]

export const defaultNew = {
  event: {
    historyId: 'new',
    audit: {
      active: true,
      modifiedBy: getLoginFromMail(getUserId()),
      modifiedDate: new Date()
    }
  },
  eventHistory: []
}

// "events": [
//   {
// "event": {
//   "id": 1,
//   "registerId": 1, //  ->  "personId": 2 -> person,
//   "date": "2001-01-01T23:28:56.782Z",
//   "startTime": "T23:28:56.782Z",
//   "endime": "T23:28:56.782Z",
//   "locationType": 1,
//   "location":"dds",
//   "type": 2,
//   "structureStatus": 3,
//   "exerciseStatus":2,
//   "expenditureStatus": 1,
//   "supervisionStatus": 1,
//   "supervisorName": "ddd",
//   "supervisorRole": 2,
//   "meetingPurpose" :2,
//   "involvedName": "ddd",
//   "theirRoleInvolved": 2,
//   "involved": 1,
//   "notes": "aaa"
// },
// "eventHistory": {

// }
//   }
// ]



// WEBPACK FOOTER //
// ./src/register/configs/events.js